import React, {useState, useEffect } from 'react';
import jwt from 'jsonwebtoken';

export const CultureContext = React.createContext(null);

const { Provider } = CultureContext;
export const CultureProvider = ({ ...props }) => {
    const defaultCulture = "en-US"
    const [cultureName, setCultureName] = useState(null);

    const isEditingCulture = () => {
        return cultureName !== null
    }

    const isDefaultCulture = () => {
        return cultureName === null || cultureName === defaultCulture;
    }

    return (
        <Provider value={{
            setCultureName,
            cultureName,

            isEditingCulture,
            isDefaultCulture
        }}>
            {props.children}
        </Provider>
    );
}